export const ALAPADATOK_VIEW_TRANSLATIONS = {
    hu: {
        sidebar: [
            "Szak alapadatok",
            "A képzés",
            "A szak mintatanterve",
            "Tehetséges, kiemelkedő hallgatói teljesítmények",
            "Idegen nyelvi követelmények",
            "Kötelező szakmai gyakorlat",
            "Mintatanterv fejlesztések, módosítások",
            "Fejlesztési javaslatok",
            "Oktatás",
            "A szak hallgatóira vonatkozó adatok",
            "Versenytárs elemzés",
            "Meghívott előadók és óraadók",
            "Oktatók értékelése",
            "A képzés tanulmányi körülményei",
            "A szak kommunikációja",
            "Fejlesztési javaslatok megvalósítása és értékelése",
            "Szakjelentés lezárása"
        ],
        pageTitle: "Szak alapadatok",
        loading: "Loading...",
        kepzesNeve: "Képzés neve:",
        kepzesiSzint: "Képzési szint:",
        kepzesiTerulet: "Képzési terület:",
        kreditszam: "Kreditszám:",
        munkarend: "Munkarend:",
        kepzesiForma: "Képzési forma:",
        specializaciok: "Specializációk:",
        engedelySzam: "Engedélyszám:",
        szakInditas: "Szak indításának első tanéve:",
        gondozoKar: "Képzést gondozó kar:",
        gondozoTanszek: "Képzést gondozó tanszék:",
        szakfelelosNeve: "Szakfelelős neve:",
        nextSection: "Következő szakasz"
    },
    en: {
        sidebar: [
            "Programme Basic Data",
            "The Programme",
            "Programme Curriculum",
            "Talented Students and Outstanding Student Performance",
            "Foreign Language Requirements",
            "Compulsory Professional Practice",
            "Curriculum Developments and Modifications",
            "Development Recommendations",
            "Teaching",
            "Data related to the major",
            "Competitor Analysis",
            "Guest Lecturers and Part-time Teachers",
            "Assessment of Teachers",
            "Study Conditions",
            "Programme Communication",
            "Implementation and Evaluation of Development Recommendations",
            "Finalisation of Programme Report"
        ],
        pageTitle: "Programme Basic Data",
        loading: "Loading...",
        kepzesNeve: "Programme Name:",
        kepzesiSzint: "Programme Level:",
        kepzesiTerulet: "Field of Study:",
        kreditszam: "Number of Credits:",
        munkarend: "Schedule:",
        kepzesiForma: "Study Mode:",
        specializaciok: "Specialisations:",
        engedelySzam: "Permit Number:",
        szakInditas: "Programme Launch Year:",
        gondozoKar: "Faculty Managing the Programme:",
        gondozoTanszek: "Department Managing the Programme:",
        szakfelelosNeve: "Programme Director:",
        nextSection: "Next Section"
    }
};

